import { PasswordRequiredError } from '../../errors';
export class LocalStringStore {
    constructor(storage) {
        this.storage = storage;
    }
    async getWallets() {
        const keys = await this.storage.getAllKeys();
        const values = await Promise.all(keys.map(async (key) => this.storage.getItem(key)));
        return values.map((value) => JSON.parse(value));
    }
    async saveWallet(wallet) {
        let safeWallet = wallet;
        if (wallet.userAccount.id.network === 'main') {
            if (wallet.nep2 === undefined) {
                throw new PasswordRequiredError();
            }
            safeWallet = {
                type: 'locked',
                userAccount: wallet.userAccount,
                nep2: wallet.nep2,
            };
        }
        await this.storage.setItem(this.getKey(safeWallet), JSON.stringify(safeWallet));
    }
    async deleteWallet(wallet) {
        await this.storage.removeItem(this.getKey(wallet));
    }
    getKey({ userAccount: { id: { network, address }, }, }) {
        return `${network}-${address}`;
    }
}

//# sourceMappingURL=LocalStringStore.js.map
